module.exports = __webpack_public_path__ + "static/media/expand.85c31e94.svg";